export default {
  inject: ['load'],
  data() {
    return {
      allHeadacheLocationsForOther: [],
      headacheLocation: null,
    };
  },
  methods: {
    getListOfHeadacheLocationsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllHeadacheLocations').then(() => {
        if (this.$store.state.headacheLocationModule.successFlag) {
          this.allHeadacheLocationsForOther =
            this.$store.state.headacheLocationModule.allHeadacheLocations;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.headacheLocationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfHeadacheLocationsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getHeadacheLocationFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getHeadacheLocation', id).then(() => {
        if (this.$store.state.headacheLocationModule.successFlag) {
          this.headacheLocation = this.$store.state.headacheLocationModule.headacheLocation;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.headacheLocationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getHeadacheLocationFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.headacheLocationModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
